/* eslint-disable max-len */

export const ArrowBackIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_2643_6632"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2643_6632)">
        <path
          d="M15.1248 21.1004L6.6998 12.7004C6.5998 12.6004 6.52897 12.4921 6.4873 12.3754C6.44564 12.2587 6.4248 12.1337 6.4248 12.0004C6.4248 11.8671 6.44564 11.7421 6.4873 11.6254C6.52897 11.5087 6.5998 11.4004 6.6998 11.3004L15.1248 2.87539C15.3581 2.64206 15.6498 2.52539 15.9998 2.52539C16.3498 2.52539 16.6498 2.65039 16.8998 2.90039C17.1498 3.15039 17.2748 3.44206 17.2748 3.77539C17.2748 4.10872 17.1498 4.40039 16.8998 4.65039L9.5498 12.0004L16.8998 19.3504C17.1331 19.5837 17.2498 19.8712 17.2498 20.2129C17.2498 20.5546 17.1248 20.8504 16.8748 21.1004C16.6248 21.3504 16.3331 21.4754 15.9998 21.4754C15.6665 21.4754 15.3748 21.3504 15.1248 21.1004Z"
          fill="#374151"
        />
      </g>
    </svg>
  );
};

export const WhiteArrowBackIcon = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_2340_48014"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="12"
        y="12"
        width="24"
        height="24"
      >
        <rect x="12" y="12" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2340_48014)">
        <path
          d="M27.1248 33.1004L18.6998 24.7004C18.5998 24.6004 18.529 24.4921 18.4873 24.3754C18.4456 24.2587 18.4248 24.1337 18.4248 24.0004C18.4248 23.8671 18.4456 23.7421 18.4873 23.6254C18.529 23.5087 18.5998 23.4004 18.6998 23.3004L27.1248 14.8754C27.3581 14.6421 27.6498 14.5254 27.9998 14.5254C28.3498 14.5254 28.6498 14.6504 28.8998 14.9004C29.1498 15.1504 29.2748 15.4421 29.2748 15.7754C29.2748 16.1087 29.1498 16.4004 28.8998 16.6504L21.5498 24.0004L28.8998 31.3504C29.1331 31.5837 29.2498 31.8712 29.2498 32.2129C29.2498 32.5546 29.1248 32.8504 28.8748 33.1004C28.6248 33.3504 28.3331 33.4754 27.9998 33.4754C27.6665 33.4754 27.3748 33.3504 27.1248 33.1004Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
